<app-auth-header></app-auth-header>

<div
  class="relative h-[94%] bg-cover bg-center text-white flex items-center justify-center "
  style="background-image: url('assets/images/home_bg_img.png')"
>
  <div class="absolute inset-0 bg-[#272c36] bg-opacity-60"></div>

  <div
    class="fixed z-10  justify-center w-[53.281vw] max-h-[72vh] mb-24 bg-[#F1F3F5] rounded-[4px]  "
  >
    <div class="flex flex-col items-center">
      <h3
        class="!text-[#21252A] !text-center !mt-[45px] !text-[2rem] !font-bold font-roboto w-[377px] justify-center leading-[57.6px] "
      >
        Recover Your Account
      </h3>
      <h6
        class="text-[#343A40] !text-[1.25rem]  !mt-[20px] !text-center !font-semibold  text-custom leading-6 tracking-tight-negative"
      >
      Enter your email address associated with your account.
      </h6>
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="w-[100%] mt-[20px]">
          <div class="flex items-center justify-left">
            <div class="relative w-[410px] mb-10 mt-[19px]" >
              <mat-form-field appearance="outline" class="w-[100%]">
                <mat-label>Email</mat-label>
                <mat-icon matPrefix class="text-[#FF6F00]">email</mat-icon>
                <input
                  matInput
                  id="email"
                  formControlName="email"
                  type="email"
                  placeholder="Enter Your Email"
                  class="bg-[#F1F3F5] text-[#21252A] rounded-[10px]"
                />
                   <!-- Error message -->
                   <mat-error *ngIf="registerForm.get('email')?.errors?.['required']">
                    Email is required
                  </mat-error>
                
                  <!-- Error message for invalid email format -->
                  <mat-error *ngIf="registerForm.get('email')?.errors?.['email']">
                    Invalid email format
                  </mat-error>
              </mat-form-field>
             
            </div>
            
          </div>
         
        </div>
        <div class="flex justify-center">
          <div class="w-[377px] flex  justify-end mb-[30px] ml-[115px]">
            <button
              (click)="navigateToLogin()"
              type="button"
              class="flex w-[105px] !text-[1rem] h-[48px] !text-[#E76B3F] font-semibold hover:bg-[#fcfffd] p-[14px] mr-[10px]  border border-[#E76B3F] justify-center items-center gap-[10px] rounded-[5px] bg-[#F1F3F5]"
            >
              Cancel
            </button>
            <button
              (click)="checkEmail()"
              type="button"
              class="flex w-[105px] !text-[1rem] shadow-custom h-[48px]  font-semibold justify-center items-center gap-[10px] rounded-[5px] bg-[#E76B3F]"
            >
              Send
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="w-full fixed bottom-0  z-50">
  <app-footer></app-footer>
</div>